import { Badge } from "../../design-system";
import type { OrgRole } from "../../identity";

/** The one place the org role maps to a badge tone/label (used by the members
 *  table, the org overview, and the profile panel). */
export function OrgRoleBadge({ role }: { role: OrgRole }) {
  return role === "ADMIN" ? (
    <Badge tone="brand">Admin</Badge>
  ) : (
    <Badge tone="neutral">Member</Badge>
  );
}
